import PropTypes from 'prop-types'
import { MPhoneNumber } from './PhoneNumberType'
import { MImage } from './ImageType'
import { MFacility } from './FacilityType'
import { MRoomRates, MRoomItem } from './RoomType'

export const MHotel = PropTypes.shape({
  custom_address: PropTypes.string,
  address: PropTypes.string.isRequired,
  category_code: PropTypes.string.isRequired,
  hotel_type: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  country_code: PropTypes.string.isRequired,
  description: PropTypes.string,
  destination_code: PropTypes.string.isRequired,
  email: PropTypes.string,
  facilities: PropTypes.arrayOf(MFacility),
  health_and_safety_rating: PropTypes.string,
  id: PropTypes.number.isRequired,
  image: PropTypes.string,
  featured_images: PropTypes.oneOfType([
    MImage,
    PropTypes.arrayOf(MImage)
  ]),
  images: PropTypes.arrayOf(MImage),
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  phone_numbers: PropTypes.arrayOf(MPhoneNumber).isRequired,
  postal_code: PropTypes.string.isRequired,
  rating: PropTypes.number,
  room_rates: MRoomRates,
  rooms: PropTypes.arrayOf(MRoomItem),
  website: PropTypes.string,
  zoho_name: PropTypes.string,
})
